"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

// open_time is used when data is stream
exports.default = function (candle) {
    return [+(candle.open_time || candle.epoch) * 1000, +candle.open, +candle.high, +candle.low, +candle.close];
};